export class SendSMSRequest {
  public idUsuario: number;
  public versionAplicativo: string;
  public uuid: string;
  public telefono: string;
  public proveedorTelefonia: string;
}
